import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { LoadingDelegate } from '../../services/loading-delegate.service'

@Component({
  selector: 'ld-loading',
  template: require('./loading.component.html'),
  styles: [require('./loading.component.css')]
})
export class LoadingComponent implements OnInit {

  public show: boolean
  public message: string

  constructor (private loadingDelegate: LoadingDelegate) {
    this.update = this.update.bind(this)
  }

  ngOnInit () {
    this.loadingDelegate.subscribe(this.update)
  }

  update (data) {
    this.show = data.show
    this.message = data.message
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/loading/loading.component.ts